import { Table } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.scss';

const columns = [
  {
    title: 'Change',
    width: 90,
    dataIndex: 'change'
  },
  {
    title: 'Reasons',
    dataIndex: 'reason',
    width: 250
  },
  {
    title: 'Date & Time',
    dataIndex: 'updatedTimestamp',
    render: (t) => <>{moment(t).format('DD/MM/YYYY[T]HH:mm:ss.SSS[Z]')}</>
  },
  {
    title: 'Changed By',
    dataIndex: 'changedBy'
  }
];

const HistoryTable = ({ scoreHistory, isFetching = false }) => {
  let data = [];
  if (Array.isArray(scoreHistory)) data = scoreHistory;
  return (
    <Table
      className={styles.table}
      dataSource={data}
      rowKey="updatedTimestamp"
      columns={columns}
      loading={isFetching}
      pagination={false}
    />
  );
};

HistoryTable.propTypes = {
  scoreHistory: PropTypes.array,
  isFetching: PropTypes.bool
};

export default HistoryTable;
